


import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios"
import { countryCodes } from '../Data/data';
export default function GetACallBack({setShow}) {
  const [formData, setFormData] = useState({
    name:"",
    email:"",
    country:"India",
    countryCode:"",
    phone:"",
    waNumber:"",
    service:"",
  });
 const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
const handleSubmit = async (e) =>{
e.preventDefault();
const { name, email, service } = formData;

    if (!name?.trim() || !email?.trim() || !service?.trim()) {
      return toast.error('Please enter your details', {
        position: 'top-right',
      });
    }
try {
  setLoading(true)
   await axios.post("https://admin.socioloom.com/test.php",formData,
  {
    headers: {
      "Content-Type": "application/json",
    }})
    
    setShow(false)
    
} catch (error) {
  console.log(error);
}
setLoading(false)
setShow(false)

}


  return (
 
    <>
    <ToastContainer />
  {loading ? (<div className='fixed h-[100%] w-[100%] z-50 bg-[#000000dd] flex items-center justify-center'>
 <div class="custom-loader"></div>
 </div>)  :
    <div className="fixed z-50 inset-0 flex items-center justify-center bg-black bg-opacity-50 mt-10" >
      <div className="bg-white p-8 rounded-md shadow-md " >
        <div className="flex justify-end">
          <button className="text-gray-500 hover:text-gray-700" onClick={()=>setShow(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
              Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Your Name"
              className="mt-1 p-2 border rounded-md w-full"
            />
          </div>
         
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="john@example.com"
              className="mt-1 p-2 border rounded-md w-full"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700">
              Phone Number {" "}<span className=' font-light'>(Optional)</span>
            </label>
            <div className="flex">
            <select name="countryCode" value={formData?.countryCode}  onChange={handleChange} className="p-2 border rounded-md w-2/5 max-sm:text-[10px] max-md:text-sm text-md text-gray-400">
            {
              countryCodes.sort((a,b)=> a.label > b.label ? 1 : -1).map((item, index)=>{
                return(
                  <option value={`${item?.value} ${item?.label}`} key={index}>{item?.label}</option>
                )
              })
            }
             
            </select>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone Number"
                className="p-2 border rounded-md w-3/4"
              />
            </div>
          </div>
          <div className="mb-4">
            <label htmlFor="whatsappNumber" className="block text-sm font-medium text-gray-700">
              WhatsApp Number
            </label>
            <input
              type="tel"
              name="waNumber"
              value={formData.waNumber}
              onChange={handleChange}
              placeholder="555-555-5555"
              className="mt-1 p-2 border rounded-md w-full"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="helpType" className="block text-sm font-medium text-gray-700">
            How We Can Help You?
            </label>
            <select
              name="service"
              value={formData.service}
              onChange={handleChange}
              className="mt-1 p-2 border rounded-md w-full"
            >
              <option disabled value="">Select an option</option>
              <option value="Web Development">Web Development</option>
              <option value="Lead Genretion">Lead Genretion</option>
              <option value="Pay Per Click (PPC)">Pay Per Click (PPC)</option>
              <option value="Social Media Marketing(SMM)">Social Media Marketing(SMM)</option>
              <option value="Search Engine Optimization(SEO)">Search Engine Optimization(SEO)</option>
              <option value="Growth Strategy">Growth Strategy</option>
              <option value="Market Research">Market Research</option>
              <option value="Business Strategy">Business Strategy</option>
              <option value="IT Solutions">IT Solutions</option>
            </select>
          </div>
          <button
            type="submit"
            className=" w-full bg-[#510069] text-white py-2 px-4 rounded-md hover:bg-blue-700"
          >
            Submit
          </button>
        </form>
      </div>
    </div>}
    </>

  )
}
